export const routes = {
  home: '/',
  refund: '/refund',
  refundDetail: '/refund-detail',
  refundStatement: '/refund-statement',
  refundDeparture: '/refund-departure',
  medicalInfo: '/medical-info',
  notice: '/home/notice',
  noticeDetail: '/home/notice/detail',
  kiosk: '/kiosk',
  ad: '/ad',
  bookStatus: '/book-status',
  globalPayment: '/global-payment',
  fxReceipt: '/fx-receipt',
  medicalTourismApply: '/medical-tourism-apply',
  imageViewer: '/image-viewer',
  discount: '/discount',
  discountDetail: '/discount-detail',
};
